import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { fetchApplicationsAsync } from 'src/private/redux/scholarship.actions';

import ApplicationComplete from '../../pages/ApplicationComplete/application-complete';
import ApplicationsForm from '../../pages/ApplicationsForm/applications-form';
import ApplicationsFormEditProfile from '../../pages/ApplicationsFormEditProfile/applications-form-edit-profile';
import ApplicationsList from '../../pages/ApplicationsList/applications-list';
import ProfilesList from '../../pages/ProfilesList/profiles-list';
import AccountLanding from '../../pages/account/account-landing';

import './private-home.css';

const PrivateHome = ({ dispatchFetchApplicationsAsync }) => {
  const { trackPageView } = useMatomo();

  // Track page view
  useEffect(() => {
    trackPageView({});
  }, []);

  useEffect(() => {
    const thisFunc = () => {
      dispatchFetchApplicationsAsync();
    };
    thisFunc();
  }, [dispatchFetchApplicationsAsync]);

  return (
    <div>
      <Routes>
        <Route index element={<ApplicationsList />} />
        <Route path="account" element={<AccountLanding />} />
        <Route path="profiles" element={<ProfilesList />} />
        <Route path="profiles/:type/:profileId" element={<ApplicationsFormEditProfile />} />
        <Route path="complete/:applicationId" element={<ApplicationComplete />} />
        <Route path=":applicationId/:step" element={<ApplicationsForm />} />
        <Route path=":applicationId" element={<ApplicationsForm />} />
      </Routes>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  dispatchFetchApplicationsAsync: () => dispatch(fetchApplicationsAsync())
});
const objConnect = connect(null, mapDispatchToProps)(PrivateHome);
export default objConnect;
